import React from "react";

const renderElement = (node: any) => {
  if (!node || !node?.tag) return null;

  return React.createElement(
    node.tag,
    { key: node._id || Math.random() },
    node.content,
    node.children && node.children.map(renderElement)
  );
};

export default renderElement;
